import * as React from 'react'

import { Button } from '@/components/ui/button'
import { Input } from '@/components/ui/input'

interface EditConversationDialogProps {
  isOpen: boolean
  conversationName: string
  onClose: () => void
  onNameChange: (name: string) => void
  onSave: () => void
}

export const EditConversationDialog: React.FC<EditConversationDialogProps> = ({
  isOpen,
  conversationName,
  onClose,
  onNameChange,
  onSave,
}) => {
  if (!isOpen) return null

  return (
    <div className="fixed inset-0 z-[10000] flex items-center justify-center p-4">
      <div className="absolute inset-0 bg-black/50" onClick={onClose} />
      <div className="relative w-full max-w-md bg-white rounded-lg shadow-xl">
        <div className="p-6">
          <div className="mb-4">
            <h3 className="text-lg font-semibold text-gray-900">Edit Conversation Name</h3>
          </div>
          <div className="space-y-4">
            <div>
              <label className="block text-sm font-medium text-gray-700 mb-2">Conversation Name</label>
              <Input
                placeholder="Enter conversation name..."
                value={conversationName}
                onChange={e => onNameChange(e.target.value)}
                onKeyPress={e => {
                  if (e.key === 'Enter') {
                    onSave()
                  } else if (e.key === 'Escape') {
                    onClose()
                  }
                }}
                autoFocus
              />
              <p className="text-xs text-gray-500 mt-1">Leave empty to use participant names by default</p>
            </div>
            <div className="flex justify-end gap-2">
              <Button variant="outline" onClick={onClose}>
                Cancel
              </Button>
              <Button onClick={onSave}>Save</Button>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}
